import router from "../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

//const state = {
//};
 
//const mutations = {
//};

const actions = {

    async new_article ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/article', {
                article: payload.article
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    // 認証不要
    async get_article_lists ({ commit }, payload) {
        return new noretryAuthAxios.get('/api/article/list')
        .catch(error => {
            reject(error);
        })
    },
    async get_article_detail_lists ({ commit }, payload) {
        var params = '?articles_id='+payload.articles_id;
        return new noretryAuthAxios.get('/api/article/detail/list'+params)
        .catch(error => {
            reject(error);
        })
    },
    async get_article_detail_info ({ commit }, payload) {
        var params = '?article_details_id='+payload.article_details_id;
        return new noretryAuthAxios.get('/api/article/detail'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_articles ({ commit }, payload) {
        var params = '?status='+payload.status;
        return new axios.get('/api/articles'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_article ({ commit }, payload) {
        return new axios.get('/api/article/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async upd_article ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/article', {
                article: payload.article
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    async upd_article_status ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/article_status', {
                article: payload.article
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async new_article_detail ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/article_detail', {
                article_detail: payload.article_detail
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_article_details ({ commit }, payload) {
        var params = '?status='+payload.status+'&id='+payload.id;
        return new axios.get('/api/article_details'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_article_detail ({ commit }, payload) {
        return new axios.get('/api/article_detail/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async upd_article_detail ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/article_detail', {
                article_detail: payload.article_detail
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    async upd_article_detail_status ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/article_detail_status', {
                article_detail: payload.article_detail
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

};

export default {
    namespaced: true,
//    state,
//    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/article.js